/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Liability_TitleInputs */

const da_terms_liability_title = /** @type {(inputs: Terms_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvar`)
};

/** @type {(inputs: Terms_Liability_TitleInputs) => LocalizedString} */
const en_terms_liability_title = da_terms_liability_title;

/**

* @param {Terms_Liability_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_liability_title = /** @type {((inputs?: Terms_Liability_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Liability_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_liability_title(inputs)
	return /** @type {LocalizedString} */ ("Ansvar")
});